import(/* webpackMode: "eager" */ "/var/www/nextjs-green/src/app/offers/page.tsx");
